export default {
      id: "icon-chevron-usage",
      viewBox: "0 0 12 7",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-chevron",
      toString: function () {
        return this.url;
      }
    }